import React from "react";

const Button = (props) => {
  const { classes, title } = props;
  return (
    <button
      type={props?.type ? props?.type : "button"}
      className={classes}
      onClick={props.onClick}
      disabled={props?.disabled ? props?.disabled : false}
    >
      {title}
      {props.children}
    </button>
  );
};

export default Button;


export const CustomButton = ({
  title,
  className = "",
  children,
  outline = false,
  disabisModalled,
  ...buttonProps
}) => {
  const baseClasses =
    "w-full py-3 px-6 text-16x font-semibold rounded-16x transition duration-150 ease-in-out";

  const solidClasses =
    "text-brand-text-primary bg-brand-base-primary border-0 hover:bg-brand-base-primary hover:text-brand-text-primary active:bg-brand-base-primary-dark";

  const outlineClasses =
    "text-brand-base-primary bg-transparent border border-brand-base-primary hover:bg-brand-base-primary hover:text-white active:bg-brand-base-primary-dark active:text-white";

  return (
    <button
      className={`${baseClasses} ${outline ? outlineClasses : solidClasses} ${className}`}
      {...buttonProps}
    >
      {title} {children}
    </button>
  );
};

